import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router"
import { B2cService } from "../services/b2c/b2c.service";
@Component({
  selector: 'app-moncompte',
  templateUrl: './moncompte.component.html',
  styleUrls: ['./moncompte.component.css']
})
export class MoncompteComponent implements OnInit {
  pageName = 'commandes'
  listCommandes:any=[];
  constructor(private router:Router,private b2cService:B2cService) { }

  ngOnInit(): void {
    let user = JSON.parse(localStorage.getItem('user'))
    this.b2cService.getCommandsUser(user.id).subscribe(res=>{
      this.listCommandes = res;
    });
  }

  logout(){
    localStorage.removeItem('user')
    localStorage.removeItem('typeCompte')
    this.router.navigate(['/']);
  }

}
